
<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/Group-51.png" width="150px" alt="register" class="mx-auto" />
              <img src="@/assets/images/Group-23.png" width="150px" alt="register" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reset Password</h4>
                  <p>Please enter your new password.</p>
                  <vs-alert
                    :active.sync="showDismissibleAlert"
                    closable
                    icon-pack="feather"
                    close-icon="icon-x"
                  >{{message}}</vs-alert>
                </div>
                <form>
                  <vs-input
                    type="email"
                    name="email"
                    label-placeholder="Email"
                    v-model="user.email"
                    class="w-full mb-6"
                    v-validate="'required|email|min:3'"
                    data-vv-validate-on="blur"
                  />
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                  <vs-input
                    name="password"
                    label-placeholder="Password"
                    v-model="user.password"
                    class="w-full mb-6"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    autocomplete="new-password"
                    icon-no-border
                    icon-pack="feather"
                  :icon="passwordIcon"
                  :type="passwordType"
                  @click.native="showHidePassword($event)"
                  />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  <vs-input
                    name="confirmPassword"
                    label-placeholder="Confirm Password"
                    v-model="user.confirmPassword"
                    class="w-full mb-8"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    autocomplete="new-password"
                    icon-no-border
                    icon-pack="feather"
                  :icon="confirmPasswordIcon"
                :type="confirmPasswordType"
                @click.native="showHideConfirmPassword($event)"
                  />
                  <span class="text-danger text-sm">{{ errors.first('confirmPassword') }}</span>
                </form>

                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button
                    class="w-full sm:w-auto"
                    :disabled="!validateForm"
                    @click="resetPassword"
                  >Reset</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
        confirmPassword: '',
        token: this.$route.params.token,
      },
      showDismissibleAlert: false,
      message: '',
      
      passwordType: 'password',
      passwordIcon: 'icon icon-eye-off',
      confirmPasswordType: 'password',
      confirmPasswordIcon: 'icon icon-eye-off',
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.user.email != '' &&
        this.user.password != '' &&
        this.user.password == this.user.confirmPassword
      );
    },
  },
  methods: {
    ...mapActions('users', ['resetPassword']),
    showHidePassword(event){
      if(event.target.className === 'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye-off null icon-no-border'
      || event.target.className === 'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye null icon-no-border')
      {
        this.passwordType === 'password' ? this.passwordType='text' : this.passwordType='password';
        this.passwordIcon === 'icon icon-eye-off' ? this.passwordIcon='icon icon-eye' : this.passwordIcon='icon icon-eye-off';
      }
      return true;
    },
    showHideConfirmPassword(event){
      if(event.target.className === 'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye-off null icon-no-border'
      || event.target.className === 'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye null icon-no-border')
      {
        this.confirmPasswordType === 'password' ? this.confirmPasswordType='text' : this.confirmPasswordType='password';
        this.confirmPasswordIcon === 'icon icon-eye-off' ? this.confirmPasswordIcon='icon icon-eye' : this.confirmPasswordIcon='icon icon-eye-off';
      }
      return true;
    },
    resetPassword() {
      const payload = {
        userDetails: this.user,
      };
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch('auth/resetPassword', payload)
            .then( () => {
              this.$vs.loading.close();
              this.$router.push('/success');
            })
            .catch(error => {
              this.showDismissibleAlert = true;
              this.message = error.message;
              this.$vs.loading.close();
              this.$vs.notify({
                title: 'Error',
                text: error.message,
                color: 'danger',
              });
            });
        }
      });
    },
  },
};
</script>
